import * as React from 'react';
import {Component} from 'react';
import Link from 'gatsby-link';

import * as FaInfo from 'react-icons/lib/fa/info';
import * as FaTwitter from 'react-icons/lib/fa/twitter';

export class SidebarContent extends Component<any, {}> {
    render() {
        return (
            <div className="sidebar">
                <div className="content">
                    <h3 className="primary">Jaanek Oja</h3>
                    <div className="info">
                        <p>Working as a contractor, freelancer.</p>
                        <p>Skills: GoLang, React, Javascript / Typescript, NodeJS, Java, Flutter, React Native, ... <a href="/skills">more</a></p>
                        <p>Co-Founder of <a href="https://www.shoppa.ee" target="_blank">Shoppa.ee</a> E-Commerce portal.</p>
                        <p>Follow me at <a href="https://twitter.com/jaanekoja" className="icon twitter"><FaTwitter/><span className="icon-text">jaanekoja</span></a></p>
                        {/*<p>Previously worked as a CTO for <b>Jawilla Software</b>, Software Developer for <b>Aqris Software</b></p>*/}

                        {/*<p>Expertise: Web Development, Developing full-stack applications</p>*/}
                        {/*<p>Education: BS Computer Science, December 2002, Tallinn, Estonia</p>*/}
                        <nav>
                            <a href="/info" className="link"><FaInfo/><span className="link-text">More info</span></a>
                        </nav>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/shared/sidebar.tsx